import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import axiosInstance from "../../shared/service/axios";
import {
  Customer,
  CustomerDeleteRequest,
  CustomerListResponse,
  CustomerUpdateRequest,
} from "./Customer.constants";

export const useCustomerListMutation = (): UseMutationResult<
  CustomerListResponse,
  AxiosError,
  any
> =>
  useMutation<CustomerListResponse, AxiosError, any>(async (requestParams) => {
    const { data, status } = await axiosInstance.get("customer/", {
      params: {
        page_size: 999999999,
      },
    });

    return data;
  });

export const useCustomerUpdateMutation = (): UseMutationResult<
  Customer,
  AxiosError,
  CustomerUpdateRequest
> =>
  useMutation<Customer, AxiosError, CustomerUpdateRequest>(
    async (requestValues: CustomerUpdateRequest) => {
      const { data, status } = await axiosInstance.put(
        "customer/" + requestValues.id + "/",
        requestValues
      );
      data.status = status;

      return data;
    }
  );

export const useCustomerDeleteMutation = (): UseMutationResult<
  any,
  AxiosError,
  CustomerDeleteRequest
> =>
  useMutation<any, AxiosError, CustomerDeleteRequest>(
    async (requestValues: CustomerDeleteRequest) => {
      const { status } = await axiosInstance.delete(
        "customer/" + requestValues.id + "/"
      );

      return status;
    }
  );
